import { TextFieldWidget } from '@tableau/widgets';
import { FormikContextType } from 'formik';
import * as React from 'react';
import { useCallback } from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { Field, FieldProps } from '../../../../FormikWrapperForStubbing';
import { tableCell, wideField } from '../../../styles/SiteNameAndIdStyles';
import { SiteNameAndIdSectionProps } from './SiteNameAndIdSection';

export function useUrlNameChangeHandler(formik: FormikContextType<SiteNameAndIdSectionProps>, setUrlNameModified: (value: boolean) => void) {
  return useCallback((e: React.ChangeEvent) => {
      setUrlNameModified(true);
      formik.setFieldTouched('settings.urlName', true, false);
    },
    [
      setUrlNameModified,
      formik.setFieldTouched,
    ]);
}

export type SiteUrlRowProps = {
  urlName: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  validator: (value: string) => string;
}

export const SiteUrlRow: React.FunctionComponent<SiteUrlRowProps> = props => {
  return <tr>
    <td className={tableCell}><label>{Messages.siteId_colon()}</label></td>
    <td>
      <Field name={'settings.urlName'}
             validate={props.validator}
      >
        {({field}: FieldProps<string>) => (
          <TextFieldWidget testId={'site-id-input'}
                           className={wideField}
                           placeholder={Messages.siteURLPlaceholderMsg()}
                           value={props.urlName}
                           maxLength={100}
                           required={true}
                           label={null}
                           name={field.name}
                           onChange={(event: any) => {
                             props.onChange(event);
                             field.onChange(event);
                           }}
          />
        )}
      </Field>
    </td>
  </tr>;
};
